module.exports = __webpack_public_path__ + "static/media/5.f1d5aa23.jpg";